// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3Ijpc","approved":"Status_approved__WbgWm","rejected":"Status_rejected__3W8Md","expired":"Status_expired__2oyYQ","label":"Status_label__TOYNa"};